var createFontFamily = require('ttf-loader/lib/create-font-family');

module.exports = createFontFamily({
  ttf: __webpack_public_path__ + "./font/732389ded34cb9c52dd88271f1345af9.ttf",
  woff: __webpack_public_path__ + "./font/535877f50039c0cb49a6196a5b7517cd.woff",
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 489
// module chunks = 0